module.exports = __webpack_public_path__ + "img/alexa12131415.a3deab46.jpg";